import { colors as uiColors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

import { colors, fonts, icons } from '@cobliteam/base-components/src/styles';

export const wrapper = css`
  color: ${colors.gray.light};
  background-color: ${uiColors.gray[12]};
  border-bottom: 1px solid ${colors.shadows.getShadow(colors.white, 0.2)};
`;

export const item = (active: boolean) => css`
  display: flex;
  height: 70px;
  margin: 10px 0;
  padding: 10px 20px;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  text-decoration-line: none;

  ${
    active &&
    css`
    background-color: ${uiColors.white.a2};
  `
  };

  > svg:last-child {
    margin-left: auto;
    color: ${colors.gray.lightest};
  }
`;

export const itemContainer = css`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const settings = css`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  max-width: 150px;

  > div > span {
    margin-top: 5px;
    color: ${colors.white};
    font-size: ${fonts.size.small};
  }

  > span {
    margin-top: 5px;
    color: ${colors.white};
  }
`;

export const chevronIcon = css`
  margin-left: auto;
`;

export const logo = (sidebarOpen: boolean) => css`
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: ${uiColors.white.a2};


  & > svg {
    font-size: ${icons.size.small};
  }

  & > img {
    width: 32px;
    height: 32px;
    border-radius: 100%;
  }
`;

export const settingsIcon = css`
  width: ${icons.size.small};
  height: ${icons.size.small};
  align-self: flex-end;
  position: absolute;
  right: -8px;
  bottom: -2px;
  background-color: ${colors.black};
  border-radius: 20px;
`;

export const imagePlaceholder = css`
  width: 13px;
  height: 13px;
  color: ${colors.custom.gray50};
`;

export const popper = css`
  && {
    min-width: 200px;
    padding: 5px 0;
    margin-left: -10px;
    border-radius: 0px;
    border-width: 0;
    background-color: ${uiColors.gray[12]};
  }
`;

export const iconWrapper = (active: boolean): string => css`
  color: ${active ? colors.white : colors.white};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  & > svg {
    font-size: ${icons.size.small};
  }
`;

export const sidebarItem = (active: boolean): string => css`
  padding: 17px 34px;
  display: flex;
  gap: 34px;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  text-decoration-line: none;
  background-color: ${active ? uiColors.white.a2 : 'transparent'};
  &:hover {
    background-color: ${uiColors.white.a2};
  }
  &a:-webkit-any-link {
    text-decoration: none;
  }
`;
